// ** Icons Import
import { Circle } from 'react-feather'

export default [
    {
        id: 'student',
        title: 'Миний мэдээлэл',
        icon: <i className="fas fa-user-graduate"></i>,
        navLink: "/student/personal-information/",
    },
    {
        id: 'student14',
        title: 'Төгсөлт',
        icon: <i className="far fa-graduation-cap"></i>,
        navLink: "/student/graduate/",
    }
]
